export default "/react/logoAlytics-a484cfa1.png";